import { useEffect, useState } from 'react'

import dayjs from '@/common/config/dayjs'

import { rangeTypes } from '../constants'
import { types as dynamicTypes } from '../DynamicDates/constants'

const useDateRangeFilter = ({ range, dynamic }) => {
  const [rangeType, setRangeType] = useState(
    dynamic?.daysGte || dynamic?.daysLte ? rangeTypes.dynamic : rangeTypes.fixed
  )
  const [startDate, setStartDate] = useState(range?.startDate ? dayjs(range.startDate, 'YYYY-MM-DD') : null)
  const [endDate, setEndDate] = useState(range?.endDate ? dayjs(range.endDate, 'YYYY-MM-DD') : null)
  const [dynamicType, setDynamicType] = useState(dynamic?.daysGte ? dynamicTypes.gte : dynamicTypes.lte)
  const [dynamicValue, setDynamicValue] = useState(dynamic?.daysGte || dynamic?.daysLte || 0)

  useEffect(() => {
    if (rangeType === rangeTypes.fixed) {
      setDynamicValue(null)
      setStartDate(range?.startDate ? dayjs(range.startDate, 'YYYY-MM-DD') : null)
      setEndDate(range?.endDate ? dayjs(range.endDate, 'YYYY-MM-DD') : null)
    } else {
      setStartDate(null)
      setEndDate(null)
      setDynamicType(dynamic?.daysGte ? dynamicTypes.gte : dynamicTypes.lte)
    }
  }, [rangeType, range, dynamic])

  return {
    rangeType,
    setRangeType,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    dynamicType,
    setDynamicType,
    dynamicValue,
    setDynamicValue,
  }
}

export default useDateRangeFilter
